module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length) ? _c('ul', {
    staticClass: "navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#' + item.id),
        expression: "'#'+item.id"
      }],
      class: {
        visible: item.visible
      },
      attrs: {
        "href": '#' + item.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('md-icon', [_vm._v(_vm._s(item.icon))])], 1)])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2209b364","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 27
// module chunks = 0